import { TextField } from '@fox/atoms';
import { QuestionStyleTypes, useFormRuntimeContext, useQuestionStyle } from '../../../form-runtime-context';
import { updateAnswerForContact } from '../util';
import { IAdditionalProfileFieldChoice } from './contracts';

export const CustomFieldText = (props: {
	field: IAdditionalProfileFieldChoice;
	currentAnswerSelections: any;
	currentAnswer: any;
	contactId: string;
	id: string;
	questionType: string;
}) => {
	let { field, currentAnswer, currentAnswerSelections, contactId, id, questionType } = props;
	const { answerQuestion } = useFormRuntimeContext();
	let jsonAnswer = contactId ? currentAnswerSelections?.contacts?.find(c => c.id === contactId) : undefined;
	let answer = jsonAnswer ? jsonAnswer[field?.id] : undefined;

	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.answer, {}, id);

	return (
		<TextField
			style={{ width: '100%' }}
			value={contactId ? (answer ?? '') : ''}
			onChange={c => {
				updateAnswerForContact(currentAnswer, currentAnswerSelections, contactId, answerQuestion, field.id, c.target.value, questionType);
			}}
			variant="outlined"
			sx={{
				input: {
					boxSizing: 'inherit'
				},
				'.MuiInputBase-root': {
					color,
					fontSize,
					fontStyle,
					fontFamily,
					textDecoration,
					fontWeight
				}
			}}
		/>
	);
};
